import { get, flatMap, isArray, isString, isObject, values } from 'lodash';

import { APIError } from 'api';

window.APIError = APIError;

export const DEFAULT_ERROR = 'There was an error.';

export function listErrors(errorResponse) {
    return values(errorResponseFormatter(errorResponse));
}

export function errorResponseFormatter(errorResponse, defaultMessage = DEFAULT_ERROR, flattenPaths = []) {
    // the expected key path for the error detail is errorResponse.json.detail or err..json
    // if nested in errorResponse.json.detail, add its path to the args

    if (!errorResponse) {
        return { error: defaultMessage };
    }

    let detail = defaultMessage;

    if (isObject(errorResponse.json)) {
        detail = errorResponse.json.detail || errorResponse.json;
    } else if (errorResponse.detail) {
        detail = errorResponse.detail;
    }

    if (isString(detail)) {
        return { error: detail || defaultMessage };
    }

    if (isArray(detail)) {
        return { error: detail.join(', ') || defaultMessage };
    }

    if (isObject(detail)) {
        if (flattenPaths.length > 0) {
            for (const path of flattenPaths) {
                detail = {
                    ...detail,
                    ...detail[path]
                };
            }
        }

        const keys = Object.keys(detail);
        const formatted = keys.reduce((accumulator, key) => {
            // so it isn't _always_ a list, somethings it's a string
            // iow {'email': ['this is no good']} vs {'email': 'no good'}
            const value = detail[key]; // we know detail is set, but haven't test for errorResponse.detail
            accumulator[key] = isArray(value) ? value.join(' ') : value;
            return accumulator;
        }, {});
        return formatted;
    }

    return { error: defaultMessage };
}

export function AbortController() {
    // wrap AbortController and add minimal stub
    // for browsers that don't support it yet by
    // just faking the api. no harm really, it
    // just obviously won't be aborting the requests
    if (window.AbortController) {
        return new window.AbortController();
    }

    const controller = {
        abort: () => {},
    };

    return controller;
}
